import classNames from "classnames";
import { CSSProperties } from "react";
import {
	MediaProps,
	PageSectionProps,
	TitleAndContentProps,
} from "../../../../../constants/pageSectionTypes";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import about05 from "../../../../imagenes/about-us/AboutUs_OurStory_320KB.png";
import about06 from "../../../../imagenes/about-us/Bottom Left_250KB.png";
import "./OurStory.scss";

const imagesMap = {
	About_05: about05,
	About_06: about06,
};

const OurStory = ({
	sectionContent,
	className,
}: PageSectionProps<TitleAndContentProps & { media?: MediaProps[] }>) => {
	return (
		<section
			className={classNames(
				"our-story row row--column-start row--large-screen-reverse keep-color",
				className,
			)}>
			<div className="column">
				<div className="media-container">
					{sectionContent.media &&
						sectionContent.media.length > 0 &&
						sectionContent.media.map((item) => {
							const itemStyle = {
								"--grid-row": Array.isArray(item.gridRow)
									? item.gridRow[0]
									: item.gridRow || "1/-1",
								"--grid-column": Array.isArray(item.gridColumn)
									? item.gridColumn[0]
									: item.gridColumn || "1/-1",
								...(Array.isArray(item.gridRow)
									? { "--grid-row-desktop": item.gridRow[1] }
									: {}),
								...(Array.isArray(item.gridColumn)
									? { "--grid-column-desktop": item.gridColumn[1] }
									: {}),
								"--aspect-ratio": item.aspectRatio || "auto",
							} as CSSProperties;

							return (
								<img
									key={item.img}
									className="list__item--step-img"
									src={imagesMap[item.img as keyof typeof imagesMap]}
									style={itemStyle}
								/>
							);
						})}
				</div>
			</div>
			<div className="column">
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
				<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
			</div>
		</section>
	);
};

export default OurStory;
